/** Root: wallpaper always; lock screen until an editor/admin session exists,
    then the desktop. The lock screen carries its own wallpaper (the Kigali
    Convention Centre artwork, .rdr-wall-lock), independent of the desktop
    wallpaper chosen in My profile. */
import { useAuth } from "./auth";
import { Desktop } from "./shell/Desktop";
import { LockScreen } from "./shell/LockScreen";

export function RadarRoot() {
  const { user, isLoading, isEditor } = useAuth();

  if (isLoading) {
    return <div className="rdr-wall rdr-wall-lock" aria-busy="true" />;
  }
  if (!user) {
    return (
      <>
        <div className="rdr-wall rdr-wall-lock" aria-hidden="true" />
        <LockScreen />
      </>
    );
  }
  if (!isEditor) {
    return (
      <>
        <div className="rdr-wall rdr-wall-lock" aria-hidden="true" />
        <LockScreen notEditor />
      </>
    );
  }
  return <Desktop />;
}
